import React from "react"
import styles from "./MediatorPolling.module.css";
import ContentWrapper from "../common/wrapper/ContentWrapper";
import Spinner from "../common/spinner/Spinner";

const MediatorPolling = props => {
    return (
        <ContentWrapper>
            <div className={styles.wrapper}>
                <Spinner remark={"Please wait while the application is trying to authenticate. In case the web browser opens up another instance of Genesys CloudCX, please log in and close the window afterwards"}/>
            </div>
        </ContentWrapper>
    );
}

export default MediatorPolling;